import script from "./remote.vue?vue&type=script&lang=js"
export * from "./remote.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__